import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../inputs/button';
import Constants from '../../../../definitions/constants';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import TextBoxArea from '../inputs/textBoxArea';

const GlassConfirmWithNotesPopup = props => {
  const {
    className,
    confirmTitle,
    confirmText,
    handleConfirm,
    handleCancel,
    popupState,
    loading,
    notesValue, // string: Value of the notes text area.
    notesLabelLocale, // string: Placeholder of the notes text area.
    handleOnChangeNotes, // function: Function to handle the change of the notes text area.
  } = props;
  if(!InterfaceTooling.popupHasToRender(popupState)) {
    return null;
  }
  return (
    <div className={
        "glass_popup glass_confirm_popup glass_popup_" + 
        (Constants.interface.popup.types.CENTERED) + 
        (className ? " " + className : "") +
        ((popupState && popupState.show) ? " glass_popup_visible" : "")
    }>
      <label className="modal-bg" onClick={handleCancel}></label>
      <div className="modal-content">
        <label className="close">
          <i className="fas fa-times-circle" onClick={handleCancel}></i>
        </label>
        <header>
          <h2>{confirmTitle}</h2>
        </header>
        <article className="content">
          {confirmText}
          <TextBoxArea
            className="glass_confirm_popup_text_area"
            onChange={handleOnChangeNotes}
            labelLocale={notesLabelLocale || ""}
            value={notesValue}
            data-path="notes"
          />
        </article>
        <footer>
          {handleCancel && (
            <Button
              className="glass_confirm_popup_cancel_button"
              disabled={loading}
              onClick={handleCancel}
              labelLocale={(<FormattedMessage id="common.dataTypes.boolean.no"/>)}
            />
          )}
          {handleConfirm && (
            <Button
              className="glass_confirm_popup_confirm_button"
              disabled={loading}
              loading={loading}
              onClick={handleConfirm}
              labelLocale={(<FormattedMessage id="common.dataTypes.boolean.yes"/>)}
            />
          )}
        </footer>
      </div>
    </div>
  );
};

export default GlassConfirmWithNotesPopup;



// WEBPACK FOOTER //
// ./source/client/components/common/interface/glassConfirmWithNotesPopup.jsx